import { Icon, Tooltip } from '@chocolate-soup-inc/cs-frontend-components';
import { BRICK_COLOR_CATALOG } from '../../entities/events/oneOff';
import { TBasicGiftFieldsFragment, TGiftTypes } from '../../generated/graphql';
import styles from './BrickDetails.module.scss';

type TBrickDetailsGift = Partial<Pick<TBasicGiftFieldsFragment, 'type' | 'oneOffSource' | 'brickColor' | 'brickSize' | 'brickQuantity' | 'brickText'>>;

export const hasBrickDetails = (gift: TBrickDetailsGift) =>
  Boolean(
    gift.oneOffSource ||
    (gift.type != null &&
      [TGiftTypes.BabyGift, TGiftTypes.Bereavement, TGiftTypes.Wedding, TGiftTypes.ReplacementWorkAnniversary, TGiftTypes.ReplacementEmployeeBirthday, TGiftTypes.CarePackage, TGiftTypes.CustomBricks, TGiftTypes.Other].includes(
        gift.type
      )) ||
    gift.brickColor ||
    gift.brickSize ||
    gift.brickQuantity ||
    gift.brickText
  );

export const BrickDetails = ({ gift }: { gift: TBrickDetailsGift }) => {
  const color = gift.brickColor ? BRICK_COLOR_CATALOG[gift.brickColor] : undefined;

  return (
    <div className={styles.brickDetails}>
      <span className={styles.brickDetail}>
        {color && <span aria-hidden='true' className={styles.colorSwatch} style={{ backgroundColor: color.background }} />}
        {color?.label || gift.brickColor || '-'}
      </span>
      <span className={styles.brickDetail} aria-label={`Brick Size: ${gift.brickSize || '-'}`}>
        <Tooltip message='Brick Size'>
          <Icon icon='straighten' />
        </Tooltip>
        {gift.brickSize || '-'}
      </span>
      <span className={styles.brickDetail} aria-label={`Brick Quantity: ${gift.brickQuantity ?? 1}`}>
        <Tooltip message='Brick Quantity'>
          <Icon icon='inventory_2' />
        </Tooltip>
        {gift.brickQuantity ?? 1} pc(s)
      </span>
      <span className={styles.brickDetail} aria-label={`Brick Text: ${gift.brickText || '-'}`}>
        <Tooltip message='Printed Text'>
          <Icon icon='print' />
        </Tooltip>
        {gift.brickText || '-'}
      </span>
    </div>
  );
};
